/* ============================================================
   YoFresh Sticky ATC bar.
   - Shows after user scrolls past `data-reveal-after` px
   - Mirrors the hero's current selection (price + pack label)
   - On tap, clicks the hero's submit button to add to cart
   - Hidden on desktop (≥990px) via CSS
   ============================================================ */

(function () {
  'use strict';

  function init() {
    const bar = document.querySelector('[data-yf-sticky-atc]');
    if (!bar) return;

    const btn = bar.querySelector('[data-yf-sticky-btn]');
    const revealAfter = parseInt(bar.dataset.revealAfter, 10) || 120;

    // Show the bar once the user scrolls past the threshold
    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const visible = window.scrollY > revealAfter;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
        document.body.classList.toggle('has-yf-sticky-atc', visible);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Mirror the bundle selection into the sticky bar
    document.addEventListener('yf:bundle:change', function (e) {
      const d = e.detail || {};
      bar.querySelectorAll('[data-yf-cta-pack]').forEach((el) => {
        el.textContent = d.packLabel || d.variantTitle || '';
      });
      bar.querySelectorAll('[data-yf-cta-price]').forEach((el) => {
        el.textContent = d.priceFormatted || '';
      });
    });

    // Tap → click the hero's main ATC button (triggers Origin's <product-form>)
    if (btn) {
      btn.addEventListener('click', function () {
        const heroBtn = document.querySelector('[data-yf-atc-main]');
        if (heroBtn) heroBtn.click();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
